import React from 'react';

import { NoDataFound } from '../icons';

export const NoDataTable = () => {
  return (
    <div
      data-testid='no-data-table'
      className='flex gap-3  flex-col text-gray items-center justify-center h-full '
    >
      <div>
        <NoDataFound className='text-pics opacity-40' />
      </div>
      <div className='text-gray'>داده‌ای برای نمایش وجود ندارد</div>
    </div>
  );
};
